import { useState, useEffect } from 'react';
import FinalCanvas from './FinalCanvas';

const FinalPreview = ({
  isHidden,
  onSizeUpdate,
  sizes,
  sourcePosition,
  profileImage,
  imageAssets,
  scale,
  canvasSize,
}) => {
  const [previewHeight, setPreviewHeight] = useState(300);
  const [previewImage, setPreviewImage] = useState(undefined);

  useEffect(() => {
    onSizeUpdate(previewHeight);
  }, [previewHeight, onSizeUpdate]);

  return (
    <div
      className="pointer-events-none overflow-hidden transform -translate-y-full rounded-full"
      style={{
        position: 'relative',
        height: `${previewHeight}px`,
        top: `-${previewHeight}px`,
      }}
    >
      <FinalCanvas
        {...sizes}
        sourcePosition={sourcePosition}
        profileImage={profileImage}
        imageAssets={imageAssets}
        scale={scale}
        onDraw={setPreviewImage}
        canvasSize={canvasSize}
      />

      <img
        id="full-preview"
        className={`${!isHidden && 'invisible'}`}
        src={previewImage}
        alt=""
        onLoad={() => {
          const element = document.getElementById('full-preview');
          setPreviewHeight(element.offsetHeight);
        }}
      />
    </div>
  );
};

export default FinalPreview;
